$(function () {
    // 全局滚动偏移量，默认值
    var defaultScrollOffset = 100; // 默认值，可调整
    var isScrolling = false; // 滚动锁，防止重复触发动画

    // 获取滚动偏移量
    function getScrollOffset(element) {
        var customOffset = $(element).data("scroll-offset");
        return customOffset !== undefined && !isNaN(customOffset)
            ? parseInt(customOffset, 10)
            : defaultScrollOffset;
    }

    // 平滑滚动到目标位置
    function smoothScrollTo(target, offset) {
        if (target.length > 0 && !isScrolling) {
            isScrolling = true;
            $("html, body").animate(
                {
                    scrollTop: target.offset().top - offset + "px"
                },
                {
                    duration: 500,
                    easing: "swing",
                    complete: function () {
                        isScrolling = false; // 动画完成后解除锁
                    }
                }
            );
        }
    }

    // 获取路径部分（保留查询字符串和哈希部分）
    function getPathname(url) {
        var a = document.createElement('a');
        a.href = url;
        return a.pathname + a.search + a.hash; // 保留路径、查询字符串和哈希
    }

    // 当前页面平滑滚动
    $(".scroll").click(function (e) {
        console.log(`scroll开始执行中....`);
        var that = $(this);
        var href = that.attr("href"); // 获取链接的 href 属性

        // 检查是否包含锚点
        if (!href.includes("#")) return; // 如果没有 #，直接退出

        var [url, hash] = href.split("#");
        var target = $("#" + hash); // 当前页面查找锚点
        var scrollOffset = getScrollOffset(that); // 获取滚动偏移量

        // 获取 href 的路径部分，保留查询字符串和哈希部分
        var pathMatch = getPathname(url) === location.pathname + location.search;

        if (hash && (url === "" || pathMatch || getPathname(url) === location.origin + location.pathname + location.search)) {
            // 当前页面的锚点跳转
            console.log(`页内跳转执行中....`);
            e.preventDefault(); // 阻止默认跳转行为
            smoothScrollTo(target, scrollOffset);
        } else if (url) {
            // 如果是跨页面的锚点跳转，存储锚点信息和偏移量
            console.log(`跨页面跳转执行中....`);
            e.preventDefault();
            sessionStorage.setItem(
                "scrollTarget",
                JSON.stringify({ hash: hash, offset: scrollOffset })
            );
            window.location.href = url + "#" + hash; // 跳转到目标页面
        } else {
            console.log(`没有执行scroll函数....`);
        }
    });

    // 页面加载后检查是否有存储的锚点
    var scrollData = sessionStorage.getItem("scrollTarget");
    if (scrollData) {
        var { hash, offset } = JSON.parse(scrollData); // 解析存储的锚点和偏移量
        var target = $("#" + hash);
        
        // 在目标元素存在的情况下执行平滑滚动
        if (target.length > 0) {
            smoothScrollTo(target, offset);
        }
        
        sessionStorage.removeItem("scrollTarget"); // 清除存储的目标
    }
});
